AuthenticationConfig.$inject = ["$mdThemingProvider"];

function AuthenticationConfig(mdThemingProvider) {

        mdThemingProvider.theme('loginTheme').foregroundPalette[3] = "rgba(0,0,0,0.67)";
}

export default AuthenticationConfig;
